export function openMethod(item) {
    this.goTo(item.url);
}
